import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { StaticTimePicker as MuiStaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import React from 'react';

import { DEFAULT_MINUTES_STEP, resolveTimeSteps } from './timePickerDefaults';

export { DEFAULT_MINUTES_STEP, DEFAULT_TIME_STEPS, resolveTimeSteps } from './timePickerDefaults';

function withMinuteStepDefaults(Component, displayName) {
    const Wrapped = React.forwardRef(function Wrapped(props, ref) {
        const { minutesStep = DEFAULT_MINUTES_STEP, timeSteps, ...rest } = props;
        const resolvedTimeSteps = resolveTimeSteps(minutesStep, timeSteps);

        return (
            <Component
                {...rest}
                ref={ref}
                minutesStep={minutesStep}
                timeSteps={resolvedTimeSteps}
                timeStep={resolvedTimeSteps.minutes}
            />
        );
    });

    Wrapped.displayName = displayName;
    return Wrapped;
}

export const TimePicker = withMinuteStepDefaults(MuiTimePicker, 'TimePicker');
export const StaticTimePicker = withMinuteStepDefaults(MuiStaticTimePicker, 'StaticTimePicker');
export const DateTimePicker = withMinuteStepDefaults(MuiDateTimePicker, 'DateTimePicker');

export default TimePicker;
